import React from 'react';
import {Button, Grid, useMediaQuery, useTheme} from "@mui/material";
import ContentContainer from "../../components/ContentContainer";
import './about.sass'
import eureyImg from '../../assets/images/eurey_nobg.png'
import {Link} from "react-router-dom";
import MarqueeAbout from "../../components/MarqueeAbout";

function About() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <ContentContainer header={'About Me'}>
            <Grid container spacing={'2rem'}>
                <Grid item xs={12} md={6}>
                    <img
                        src={eureyImg}
                        alt={"Illustration of Eurey with a laptop, trumpet, guitar, and midi keyboard, which " +
                                "are his interests drawn by Eurey."}
                        className={'about__img'}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <p className="about__info">
                      I am a second year master student at Columbia University majoring in Computer Science (Vision,
                      Graphics, Interaction, and Robotics track). For undergrad, I earned a dual degree from Columbia
                      (B.S. in Computer Engineering) and Brandeis (B.A. in Computer Science).
                    </p>
                    <p className="about__info">
                      Currently I work with &nbsp;
                      <a href={'https://www.cs.columbia.edu/~verma/index.html'} className={'about__info__link'}>
                        Professor Nakul Verma
                      </a>
                      &nbsp; and &nbsp;
                      <a href={'https://www.janelia.org/lab/branson-lab'} className={'about__info__link'}>
                        HHMI (Janelia Research Campus)
                      </a>
                      &nbsp; on designing and developing a software to analyze and predict animal (fruit flies) behavior.
                    </p>
                    <p className="about__info">
                      My passion lies in&nbsp;
                      <span className={'about__info__emphasis'}>
                        designing and developing useful, usable, and accessible applications with social
                        impact.&nbsp;
                      </span>
                      I discipline the user centered design loop starting from research, user inquiry, to
                      prototyping to find real problems that need to be solved. I provide solutions in the form of&nbsp;
                      <span className={'about__info__emphasis'}>
                        web/mobile apps&nbsp;
                      </span>
                      but I am also experienced in developing&nbsp;
                      <span className={'about__info__emphasis'}>
                          VR/AR apps, Alexa skills&nbsp;
                      </span>
                      as well as&nbsp;
                      <span className={'about__info__emphasis'}>
                        IoT products.
                      </span>
                    </p>
                    <p className="about__info">
                      My life is all about designing and engineering for social impact, video, and music!
                    </p>

                    <div className={`mb-2 ${isMobile && 'about__btns'}`}>
                        <Button
                            className={`about__btn about__resume_btn ${isMobile && 'about__resume_btn_mobile'}`}
                            variant={'contained'}
                            disableElevation
                            onClick={() => {
                                window.open("https://drive.google.com/file/d/1_TtgR3HEABau-rBxm2rdvUe7dTN5yFeT/view?usp=sharing",
                                        '_blank')
                            }}
                        >
                            Resume
                        </Button>
                        <Link to={'/more'}>
                            <Button
                                className={'about__btn about__more_btn'}
                                variant={'outlined'}
                                disableElevation
                            >
                                More About Me
                            </Button>
                        </Link>
                    </div>

                    <Grid container>
                        <Grid item xs={12}>
                            <MarqueeAbout />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ContentContainer>
    );
}

export default About;